{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "diataxis:diataxis:1.0",
  "title": "Diataxis documentation types v1.0",
  "description": "Requires `type` and constrains it to the four Diataxis forms. Adopting Diataxis is a statement that every page is one of the four, so an untyped page is a gap rather than an abstention. Like tgdp:templates:1.0 it classifies what a page *is*, so both claim the same key: stacking them narrows `type` to the intersection of the two vocabularies, so pick one. It composes freely with a schema keyed on a different field, such as passo-uno:seven-action:1.0. See https://diataxis.fr/",
  "type": "object",
  "additionalProperties": true,
  "required": ["type"],
  "properties": {
    "type": {
      "type": "string",
      "enum": ["tutorial", "how-to", "reference", "explanation"],
      "description": "Which of the four Diataxis forms this page is. `tutorial` is learning-oriented, `how-to` is task-oriented, `reference` is information-oriented, and `explanation` is understanding-oriented."
    }
  }
}
